const LEAD_TYPE = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  TOUR: 'TOUR',
  WHATSAPP: 'WHATSAPP',
}

export default LEAD_TYPE
